module.exports = __webpack_public_path__ + "img/solution_5.66ac30c8.png";